import * as Yup from 'yup';

export const removeDriverValidationSchema = Yup.object().shape({
  driverRemovalReasonKey: Yup.string().required('Please select a removal reason'),
});
